<template>
    <div class="delivery-card__container">
        <div class="delivery-card">
            <div class="delivery-card__previous" v-if="hasPreviousDay" @click="previousDelivery">
                <img class="delivery-card__arrow" src="@/assets/images/decoration/arrow-right-black.svg">
            </div>

            <div class="delivery-card__content">
                <div v-if="isPausedDay">
                    <div class="pt-2 mr-5">
                        <span v-text="$t('DELIVERY_CARD_RESUME_DELIVERY')"></span>
                        <p v-if="restartDate" v-text="restartDate"></p>
                        <unpause-button class="mt-3" :subscription="subscription" :showText="false"/>
                    </div>
                </div>
                <div v-else-if="locked">
                    <p class="delivery-card__message" v-if="selectedDelivery.delivery_scheduled" v-text="deliveryType"></p>
                    <p class="delivery-card__message" v-else v-text="$t('DELIVERY_CARD_HOLIDAY')"></p>
                </div>
                <div v-else-if="canCancelDelivery || selectedDelivery.holiday_box_id">
                    <p class="delivery-card__message" v-text="deliveryType"></p>
                    <button v-if="showSwitchBox" class="btn btn--half btn--secondary delivery-card__switch_button" @click.prevent="switchBox">
                        {{ $t('DELIVERY_CARD_SWITCH') }}
                    </button>
                    <button class="btn btn--half btn--secondary delivery-card__button" @click.prevent="createHoliday">
                        {{ $t('DELIVERY_CARD_SKIP') }}
                    </button>
                </div>
                <div v-else-if="canCreateDelivery">
                    <p class="delivery-card__message" v-text="$t('DELIVERY_CARD_HOLIDAY')"></p>
                    <button class="btn btn--half btn--secondary delivery-card__button" @click.prevent="cancelHoliday">
                        {{ $t('DELIVERY_CARD_SEND') }}
                    </button>
                </div>
                    <div v-else-if="canCancelOptInDelivery">
                    <p class="delivery-card__message" v-text="deliveryType"></p>
                    <button v-if="showSwitchBox" class="btn btn--half btn--secondary delivery-card__switch_button" @click.prevent="switchBox">
                        {{ $t('DELIVERY_CARD_SWITCH') }}
                    </button>
                    <button class="btn btn--half btn--secondary delivery-card__button" @click.prevent="cancelOptInDelivery">
                        {{ $t('DELIVERY_CARD_SKIP') }}
                    </button>
                </div>
                <div v-else-if="canCreateOptInDelivery">
                    <p class="delivery-card__message" v-text="$t('DELIVERY_CARD_HOLIDAY')"></p>
                    <button class="btn btn--half btn--secondary delivery-card__button" @click.prevent="createOptInDelivery">
                        {{ $t('DELIVERY_CARD_SEND') }}
                    </button>
                </div>
                 <div v-else-if="isHoliday && !selectedDelivery.holiday_box_id">
                    <span v-text="$t('DELIVERY_CARD_HOLIDAY')"></span>
                    <button
                        class="btn btn--half btn--secondary delivery-card__button"
                        @click.prevent="cancelHoliday">
                        {{ $t('DELIVERY_CARD_SEND') }}
                    </button>
                </div>
            </div>

            <div class="delivery-card__date-container">
                <div class="delivery-card__date">
                    <div v-text="displayDate.name"></div>
                    <div v-text="displayDate.day" class="delivery-card__date-large"></div>
                    <div v-text="displayDate.month"></div>
                </div>
            </div>

            <div class="delivery-card__next" v-if="hasNextDay" @click="nextDelivery">
                <img class="delivery-card__arrow" src="@/assets/images/decoration/arrow-right-black.svg">
            </div>
        </div>

        <div v-if="daysLeft <= 3 && !selectedDelivery.is_locked" class="delivery-card__warning">
            <img src="@/assets/images/decoration/icon-warning-white.png" class="h-6 float-left ml-6 mr-4">
            <div v-if="daysLeft" class="font-thin text-white text-sm leading-normal pr-5 py-2">
                {{ daysLeftText }} {{ !isPausedDay ? $t('DELIVERY_CARD_LEFT_TO_CHANGE') : $t('DELIVERY_CARD_LEFT_TO_RESUME')}}
            </div>
            <div v-else class="font-thin text-white text-sm leading-normal pr-5 py-2">
                {{!isPausedDay ? $t('DELIVERY_CARD_LAST_CHANCE_TO_CHANGE') : $t('DELIVERY_CARD_LAST_CHANCE_TO_RESUME')}}
            </div>
        </div>
        <div v-else class="delivery-card__border-top"></div>

        <div v-if="canCancelDelivery || canCancelOptInDelivery || selectedDelivery.holiday_box_id">
            <div v-if="!showEditForm" class="font-thin py-5 border-b border-solid border-black px-6">
                <small class="font-normal" v-text="$t('DELIVERY_CARD_DELIVERED_TO')"></small>
                <div class="no-margin leading-normal">
                    <span v-if="selectedDelivery.holiday_box_id" v-html="`${this.address.first_name} ${this.address.last_name}`"></span><br v-if="selectedDelivery.holiday_box_id"/>
                    <span v-text="address.address1"></span><br/>
                    <span v-text="address.city"></span><br/>
                    <div class="flex justify-between">
                        <div v-text="address.postcode"></div>
                        <div @click="toggleEditForm" class="underline cursor-pointer"
                            v-text="$t('DELIVERY_CARD_EDIT_ADDRESS')"
                            v-if="!selectedDelivery.holiday_box_id"></div>
                    </div>
                </div>
            </div>

            <edit-delivery-address-form
                v-else
                :subscription-id="subscription.id"
                :address="address"
                :delivery-comment="subscription.delivery_comment"
                :property-type="address.property_type"
                @subscription-address-updated="refreshDeliveries"
                @closed="toggleEditForm">
            </edit-delivery-address-form>

            <!-- Ruin the surprise -->
            <div v-if="scheduleDate"
                 class="deliveryAddressCard__action border-b"
                 @click="handleNextDeliveryBox()">
                <p class="no-margin" v-text="$t('DELIVERY_CARD_RUIN')"></p>
                <img class="deliveryAddressCard__actionIcon" src="@/assets/images/decoration/arrow-right-black.svg">
            </div>
        </div>

        <div class="delivery-card__border-bottom"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { PRODUCT_FAMILY_BUMPER, PRODUCT_FAMILY_STANDARD, DISPLAY_NAME_BUMPER, PRODUCT_FAMILY_LITE } from '@/constants/Gifting';
import {
    formatDate,
    diffDays,
    getDayFromDate,
    getStartOfDay,
    isInCurrentWeek,
    setDayOfWeek,
} from '@/helpers/DateHelpers';
import * as Dates from '@/constants/Dates';
import { SUBSCRIPTION_STATUS_PAUSED } from '@/constants/Subscription';
import EditDeliveryAddressForm from '@/components/forms/addresses/EditDeliveryAddressForm';
import ScheduledOrderService from '@/services/subscriptions/Subscriptions/ScheduledOrderService';
import UnpauseButton from '../../my-delivery-addresses/UnpauseButton.vue';
import { CSPageEvents } from '@/helpers/GAHelpers';

let scheduledOrderService = new ScheduledOrderService();

export default {
    name: 'DeliveryCard',
    components: {
        EditDeliveryAddressForm,
        UnpauseButton,
    },
    data() {
        return {
            showEditForm: false,
        };
    },
    mounted() {
        this.$store.dispatch('subscription/fetchAllSubscriptions');
    },
    computed: {
        ...mapGetters({
            addressById: 'address/getAddressById',
            allDeliveries: 'scheduledOrder/getAllDeliveries',
            deliveries: 'scheduledOrder/getDeliveries',
            schedules: 'cms/getSchedules',
            selectedDelivery: 'scheduledOrder/getSelectedDelivery',
            subscription: 'subscription/getActiveSubscription',
            optInDeliveryDays: 'scheduledOrder/getOptInDeliveryDays',
            skipDeliveryPopupEnabled: 'account/getSkipDeliveryPopupEnabled',
            firstCutOff: 'scheduledOrder/getFirstCutOffDay',
            holidayGiftingEnabled: 'account/getHolidayGiftingEnabled',
            deferWeekEnabled: 'account/getShiftDeliveryScheduleEnabled',
        }),
        address() {
            if (this.selectedDelivery.holiday_box_id) return this.selectedDelivery.holiday_gift_address;
            return this.subscription ? this.addressById(this.subscription.delivery_address_id) : {};
        },
        showSwitchBox() {
            return this.selectedDelivery.product_family?.toLowerCase() === PRODUCT_FAMILY_BUMPER && this.subscription.product_family?.toLowerCase() === PRODUCT_FAMILY_STANDARD;
        },
        locked() {
            return this.selectedDelivery.is_locked;
        },
        isOptInDelivery() {
            return this.selectedDelivery.delivery_type === 'opt-in';
        },
        canCancelDelivery() {
            return this.selectedDelivery.delivery_scheduled && !this.locked && !this.isOptInDelivery;
        },
        canCreateDelivery() {
            return !this.selectedDelivery.delivery_scheduled && !this.locked && !this.isOptInDelivery;
        },
        canCancelOptInDelivery() {
            return this.selectedDelivery.delivery_scheduled && !this.locked && this.isOptInDelivery;
        },
        canCreateOptInDelivery() {
            return !this.selectedDelivery.delivery_scheduled && !this.locked && this.isOptInDelivery;
        },
        daysLeft() {
            const firstCutOff = new Date(this.firstCutOffDay);
            const cutOffWeekday = getDayFromDate(setDayOfWeek(new Date(), this.cutOffDayName));
            const deliveryWeekday = getDayFromDate(this.day);
            let cutOffDaysNumber = Math.abs(cutOffWeekday - deliveryWeekday);

            if (cutOffWeekday > deliveryWeekday) {
                cutOffDaysNumber = Math.abs(cutOffWeekday - 7 - deliveryWeekday);
            }
            const daysLeftTillCutOff = diffDays(this.day, firstCutOff) - diffDays(getStartOfDay(this.today), firstCutOff) - cutOffDaysNumber;
            return daysLeftTillCutOff;
        },
        daysLeftText() {
            return daysLeft === 1 ? `${daysLeft} day` : `${daysLeft} days`;
        },
        displayDate() {
            return {
                name: formatDate(this.selectedDateTime, Dates.SHORT_DAY),
                day: formatDate(this.selectedDateTime, Dates.SINGLE_NUMBER_DAY),
                month: formatDate(this.selectedDateTime, Dates.SHORT_MONTH),
            };
        },
        hasPreviousDay() {
            const firstDayInDeliveries = this.allDeliveries[0].datetime;
            return this.selectedDelivery.datetime !== firstDayInDeliveries;
        },
        hasNextDay() {
            const lastDayInDeliveries = this.allDeliveries.slice(-1)[0].datetime;
            return this.selectedDelivery.datetime !== lastDayInDeliveries;
        },
        isHoliday() {
            return this.selectedDelivery.type === 'normal' && this.selectedDelivery.delivery_scheduled === false;
        },
        isPausedDay() {
            const hasPausedSubscription = this.subscription && this.subscription.status === SUBSCRIPTION_STATUS_PAUSED;
            return hasPausedSubscription && !this.locked;
        },
        restartDate() {
            const restartDate = this.subscription.resume_date || null;
            return restartDate ? this.$t('DELIVERY_CARD_RESTART_DATE', { restartDate: formatDate(restartDate, Dates.DAY_DATE_MONTH_YEAR) }) : false;
        },
        scheduleDate() {
            return this.schedules.reduce((scheduleId, schedule) => {
                return isInCurrentWeek(this.selectedDateTime, schedule.deliveries_start_at) ? schedule.deliveries_start_at : scheduleId;
            }, false);
        },
        selectedDateTime() {
            return this.selectedDelivery.shift_delivery_date || this.selectedDelivery.newDate || this.selectedDelivery.datetime;
        },
        deliveryType() {
            if (this.selectedDelivery.product_family === PRODUCT_FAMILY_BUMPER) return this.$t('DELIVERY_CARD_SCHEDULE_BUMPER', { theBox: DISPLAY_NAME_BUMPER });
            if (this.selectedDelivery.product_family === PRODUCT_FAMILY_STANDARD) return this.$t('DELIVERY_CARD_SCHEDULE_STANDARD');
            if (this.selectedDelivery.product_family === PRODUCT_FAMILY_LITE) return this.$t('DELIVERY_CARD_SCHEDULE_LITE');
            return 'DELIVERY_CARD_SCHEDULE';
        },
    },
    methods: {
        cancelHoliday() {
            CSPageEvents('send-me-flowers');
            scheduledOrderService.cancelHoliday({
                subscriptionId: this.subscription.id,
                holidayId: this.selectedDelivery.holiday_id,
            }).then(() => this.handleRefresh());
        },

        switchBox() {
            this.$store.dispatch('subscription/updateProductType', { subId: this.subscription?.id, prodId: null, name: this.subscription.product_family, date: this.selectedDateTime })
                .then(() => {
                    this.$store.dispatch('scheduledOrder/fetchAllDeliveries', true);
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        cancelOptInDelivery() {
            scheduledOrderService.cancelOptInOrder({
                subscriptionId: this.subscription.id,
                optInBoxId: this.selectedDelivery.opt_in_box_id,
            }).then(() => this.handleRefresh(true));
        },

        createHoliday() {
            CSPageEvents('skip-delivery');
            if (this.holidayGiftingEnabled && !this.deferWeekEnabled) {
                this.$store.commit('gifting/setShowHolidayBoxModal', true);
            } else {
                scheduledOrderService.createHoliday({
                    subscriptionId: this.subscription.id,
                    deliveryDate: this.selectedDateTime,
                }).then(() => {
                    if (this.skipDeliveryPopupEnabled && this.subscription.skipping_delivery_count === 4) this.$emit('skipped-fifth-delivery', { subscriptionId: this.subscription.id, deliveryDate: this.selectedDelivery.datetime });
                    this.handleRefresh(true);
                });
            }
        },

        createOptInDelivery() {
            scheduledOrderService.createOptInOrder({
                subscriptionId: this.subscription.id,
                deliveryDate: this.selectedDateTime,
            }).then(() => this.handleRefresh());
        },

        handleRefresh(emitRecentlySkippedDelivery) {
            this.$emit('holiday-button-clicked');
            if (emitRecentlySkippedDelivery) this.$emit('has-recently-skipped-delivery');
            this.refreshDeliveries();
            this.refreshShopOrderSummary();
            this.$store.dispatch('subscription/fetchAllSubscriptions', true);
        },

        nextDelivery() {
            const currentDateIndex = this.allDeliveries.findIndex((item) => item.datetime === this.selectedDelivery.datetime);
            const nextDelivery = this.allDeliveries[currentDateIndex + 1];
            const nextDeliveryDate = nextDelivery && (nextDelivery.shift_delivery_date || nextDelivery.datetime);
            this.$store.dispatch('scheduledOrder/selectDeliveryDay', nextDeliveryDate);
            this.$root.$emit('delivery-card-day-selected', nextDeliveryDate);
        },

        previousDelivery() {
            const currentDateIndex = this.allDeliveries.findIndex((item) => item.datetime === this.selectedDelivery.datetime);
            const previousDelivery = this.allDeliveries[currentDateIndex - 1];
            const previousDeliveryDate = previousDelivery && (previousDelivery.shift_delivery_date || previousDelivery.datetime);
            this.$store.dispatch('scheduledOrder/selectDeliveryDay', previousDeliveryDate);
            this.$root.$emit('delivery-card-day-selected', previousDeliveryDate);
        },

        refreshDeliveries() {
            this.$store.dispatch('scheduledOrder/fetchAllDeliveries', true);
        },

        refreshShopOrderSummary() {
            this.$store.dispatch('shop/fetchOrderSummary', true);
            this.$store.dispatch('shop/getNextDeliveryDate', true);
        },

        toggleEditForm() {
            this.showEditForm = !this.showEditForm;
        },

        handleNextDeliveryBox() {
            this.$router.push({
                name: 'account.your-boxes.redirect',
                params: {
                    scheduleDate: this.scheduleDate,
                    subscriptionId: this.subscription.id,
                },
            });
        },
    },
    watch: {
        subscription() {
            this.$store.dispatch('cms/fetchSchedules');
        },
    },
};
</script>

<style lang="scss" scoped>
.delivery-card__container {
    background-color: white;
    @screen md {
        border: 1px solid black;
        border-bottom-width: 0;
        padding-top: 12px;
    }
}

.delivery-card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px 12px;
}

.delivery-card__content {
    width: 60%;
    padding: 12px;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.delivery-card__message {
    line-height: 20px;
    font-weight: 200;
    font-size: 20px;
    margin: 4px;
}

.delivery-card__button {
    font-size: 16px;
    margin-top: 12px;
    @screen sm {
        font-size: 18px
    }
}

.delivery-card__switch_button {
    font-size: 16px;
    margin-top: 12px;
    padding: 8px 25px;
    @screen sm {
        font-size: 18px
    }
}

.delivery-card__warning {
    background-color: #B1473C;
    display: flex;
    border: 1px solid black;
    border-right-width: 0;
    border-left-width: 0;
    align-content: center;
}

.delivery-card__previous {
    width: 12px;
    align-content: center;
    transform: rotate(180deg);
}

.delivery-card__arrow {
    object-fit: fill;
    cursor: pointer;
}

.delivery-card__next {
    width: 12px;
    align-content: center;
}

.delivery-card__date-container {
    width: 100px;
    font-size: 14px;
    margin: 12px;
    @screen sm {
        font-size: 16px
    }
}

.delivery-card__date {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    text-align: center;
    font-weight: 200;
    text-transform: uppercase;
    padding: 12px 0 8px;
    line-height: 1;
}

.delivery-card__date-large {
    font-size: 30px;
    @screen md {
        font-size: 48px;
        margin-bottom: -4px;
    }
}

.delivery-card__border-bottom {
    border-bottom: 1px solid black;
    float: right;
    @screen md {
        border-bottom-width: 0;
    }
}

.delivery-card__border-top {
    border-top: 1px solid black;
}
</style>
